var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input",class:{
        'input--dirty': _vm.value || _vm.focus,
        'input--focus': _vm.focus,
        'input--error': _vm.error,
        'input--textarea': _vm.component === 'textarea',
    }},[_c('span',{staticClass:"input__placeholder"},[_c('transition',{attrs:{"name":"placeholder-transition"}},[(_vm.error)?_c('div',{key:"error"},[_vm._v(_vm._s(_vm.error))]):_c('div',{key:"placeholder"},[_vm._v(_vm._s(_vm.placeholder))])])],1),_c(_vm.component,_vm._b({ref:"input",tag:"component",class:{
            input__inner: true,
            input__textarea: _vm.component === 'textarea',
        },attrs:{"type":_vm.type,"value":_vm.value,"maskOptions":_vm.mask,"inputmode":_vm.inputmode},on:{"input":_vm.onInput,"focus":function($event){_vm.focus = true},"blur":function($event){_vm.focus = false}}},'component',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }